import { Component, Input } from "@angular/core";

@Component({
  selector: 'app-sqc-replace-modal',
  template: `
    <nz-table>
      <thead>
        <tr>
          <th>Product Code</th>
          <th>Description</th>
          <th>Unit</th>
          <th>Location</th>
          <th>Qty on Hand</th>
          <th>Out Qty</th>
          <th>Final Qty</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of details">
          <td>{{ item.stockCode }}</td>
          <td>{{ item.stockName }}</td>
          <td>{{ item.unitCode }}</td>
          <td>{{ item.locationCode }}</td>
          <td style="text-align: center">{{ item.qtyOnHand }}</td>
          <td style="text-align: center">{{ item.outQty }}</td>
          <td style="text-align: center">{{ item.qtyOnHand - item.outQty }}</td>
        </tr>
      </tbody>
    </nz-table>
  `,
  standalone: false
})
export class StockQuantityControlModalComponent {
  @Input() details!: any[];
}